import { Injectable } from '@angular/core';

import { MyBetsEarlyPayoutServiceEditBetFactory } from '../../../../lib/my-bets-base/early-payout/my-bets-earlypayout.service.factory';
import { MyBetsBetSlip } from '../../../../lib/my-bets-base/models/my-bets-viewmodels';
import { EditBetEarlyPayoutSubscriptionService } from './edit-bet-early-payout-subscription.service';

@Injectable()
export class EditBetEarlyPayoutSubscriptionServiceFactory {
    constructor(private earlyPayoutService: MyBetsEarlyPayoutServiceEditBetFactory) {}

    createAndSubscribe(betslip: MyBetsBetSlip): EditBetEarlyPayoutSubscriptionService {
        const service = new EditBetEarlyPayoutSubscriptionService(betslip, this.earlyPayoutService.create());
        service.subscribe();

        return service;
    }
}
